import type { ReactNode } from 'react';

import { Badge, Select } from '../atoms';
import { SqlPreview } from '../molecules';
import { useSqlLibrary } from '../../lib/queries';

export function SqlLibrarySelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (id: string) => void;
}): ReactNode {
  const library = useSqlLibrary();
  const selected = library.data?.find((item) => item.id === value);

  return (
    <div className="space-y-2">
      <Select value={value} onChange={(event) => onChange(event.target.value)}>
        <option value="">{library.isLoading ? 'Carregando…' : 'Selecione um item salvo'}</option>
        {library.data?.map((item) => (
          <option key={item.id} value={item.id}>
            {item.title}
            {item.readOnly ? ' (leitura)' : ' (escrita)'}
          </option>
        ))}
      </Select>

      {selected && (
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Badge tone={selected.readOnly ? 'accent' : 'warning'}>
              {selected.readOnly ? 'somente leitura' : 'contém escrita'}
            </Badge>
            {selected.tags.map((tag) => (
              <Badge key={tag}>{tag}</Badge>
            ))}
          </div>
          <SqlPreview sql={selected.sqlBody} label={selected.title} />
        </div>
      )}
    </div>
  );
}
